<dl [class]="additionalCssForDlElement()">
  @if (dataType() !== PreviewDataType.CHECKBOX) {
    <dt [class]="additionalCssClasses()">
      <span class="label-content">
        <span class="font-bold">{{ label() }}</span>
        @if (labelTooltip()) {
          <i
            class="pi pi-info-circle cursor-help label-tooltip-icon"
            [pTooltip]="labelTooltip()"
            tooltipPosition="top"
          ></i>
        }
      </span>
    </dt>
  }
  @switch (dataType()) {
    @case (PreviewDataType.DATE) {
      <dd>
        {{ data() == null ? emptyValue() : (data() | date: 'yyyy-MM-dd') }}
      </dd>
    }
    @case (PreviewDataType.CURRENCY) {
      <dd>{{ data() == null ? emptyValue() : (data() | currency) }}</dd>
    }
    @case (PreviewDataType.TEXT) {
      <dd [class]="additionalCssClassesForTextData()">
        {{ textValue() }}
      </dd>
    }
    @case (PreviewDataType.STATUS) {
      <dd class="mt-1">
        <p-tag
          [value]="data()"
          [rounded]="true"
          [severity]="statusSeverity()"
          class="preview-status-tag"
        ></p-tag>
      </dd>
    }
    @case (PreviewDataType.BOOLEAN) {
      <dd>{{ data() ? 'Prawda' : 'Fałsz' }}</dd>
    }
    @case (PreviewDataType.CHECKBOX) {
      <label class="ml-2 my-4">
        <p-checkbox
          [binary]="true"
          [ngModel]="data()"
          class="customCheckbox"
          [disabled]="true"
        ></p-checkbox>
        <span class="ml-2">
          {{ label() }}
        </span>
      </label>
    }
    @case (PreviewDataType.HTML) {
      <dd [innerHTML]="data()"></dd>
    }
    @case (PreviewDataType.ARRAY) {
      <dd>{{ data() | json }}</dd>
    }
    @case (PreviewDataType.PERCENT) {
      <dd>{{ data() == null ? emptyValue() : (data() | percent) }}</dd>
    }
    @case (PreviewDataType.DATE_TIME) {
      <dd>
        {{
          data() == null
            ? emptyValue()
            : (data() | date: 'yyyy-MM-dd HH:mm:ss')
        }}
      </dd>
    }
    @default {
      <dd>{{ data() }}</dd>
    }
  }
</dl>
